import { RouterLink } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-sidebar-create-sr-button',
  standalone: true,
  imports: [MatIconModule, MatRippleModule, RouterLink],
  templateUrl: './sidebar-create-sr-button.component.html',
  styleUrls: ['./sidebar-create-sr-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SidebarCreateSrButtonComponent {}
